module.exports = __webpack_public_path__ + "static/img/logo01.9c6cc51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/keke/logo01.png
// module id = /t++
// module chunks = 0